import { useEffect , useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { saveTokenWithExpiry, getValidToken } from "./tokenUtils.js";
import { useSalesContext } from "../Pages/SalesContext.js";

 
export const useTokenFromQuery = (dashboardPath) => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const queryToken = queryParams.get("access_token");

    if (queryToken) {
      try {
        const decoded = jwtDecode(queryToken);
        if (decoded?.preferred_username) {
          saveTokenWithExpiry(queryToken);
          navigate(dashboardPath, { replace: true });
        } else {
          throw new Error("JWT is malformed");
        }
      } catch (err) {
        console.error("Invalid JWT Token:", err);
        alert("Session expired or invalid token. Please login again.");
        navigate("/", { replace: true });
      }
    }
  }, [location, navigate, dashboardPath]);
};

// export const useFetchUserDetails = (
//   setUserLocation,
//   setHeaderUsername,
//   setRefreshTime,
//   apiBaseUrl,
//   dashboardName
// ) => {
//   const { setLoading } = useSalesContext();
//   const location = useLocation();

// //   useEffect(() => {
// //     const queryParams = new URLSearchParams(location.search);
// //     const queryToken = queryParams.get("access_token") || getValidToken();

// //     if (queryToken) {
// //       try {
// //         const decoded = jwtDecode(queryToken);
// // console.log("Decoded Token:", decoded);
// //         if (!decoded?.preferred_username) {
// //           throw new Error("Invalid JWT token structure.");
// //         }

// //         fetch(`${apiBaseUrl}User/UserDetails`, {
// //           headers: {
// //             Authorization: `Bearer ${queryToken}`,
// //             "Content-Type": "application/json",
// //           },
// //         })
// //           .then((response) => {
// //             if (!response.ok) {
// //               throw new Error("Unauthorized or invalid response.");
// //             }
// //             return response.json();
// //           })
// //           .then((data) => {
// //             setUserLocation(data?.data?.user_Location);

// //             const rawTime = data?.data?.last_Refresh_Time;
// //             const timeWithoutZ = rawTime?.endsWith("Z")
// //               ? rawTime.slice(0, -1)
// //               : rawTime;

// //             let istTime = new Date(timeWithoutZ).toLocaleString("en-IN", {
// //               timeZone: "Asia/Kolkata",
// //               year: "numeric",
// //               month: "numeric",
// //               day: "numeric",
// //               hour: "numeric",
// //               minute: "numeric",
// //               second: "numeric",
// //               hour12: true,
// //             });

// //             istTime = istTime.replace("am", "AM").replace("pm", "PM");

// //             setRefreshTime(istTime);
// //             setHeaderUsername(data?.data?.username);
// //           })
// //           .catch((error) => {
// //             console.error("Error fetching user details:", error);
// //             alert("Failed to load user data. Please try logging in again.");
// //             setLoading(false);
// //           });
// //       } catch (err) {
// //         console.error("Invalid JWT detected during fetch:", err);
// //         alert("Invalid or expired session. Please login again.");
// //       }
// //     }
// //   }, [
// //     setLoading,
// //     location,
// //     setUserLocation,
// //     setHeaderUsername,
// //     setRefreshTime,
// //     apiBaseUrl,
// //   ]);


//   useEffect(() => {
//   const queryParams = new URLSearchParams(location.search);
//   const queryToken = queryParams.get("access_token") || getValidToken();

//   if (queryToken) {
//     try {
//       const decoded = jwtDecode(queryToken);
//       console.log("Decoded Token:", decoded);

//       if (!decoded?.preferred_username) {
//         throw new Error("Invalid JWT token structure.");
//       }

//       // Assuming `dashboardName` is a variable coming from props/state
//       const requestBody = {
//         dashboardName: dashboardName, // replace with your variable
//       };

//       fetch(`${apiBaseUrl}User/UserDetails`, {
//         method: "POST",
//         headers: {
//           Authorization: `Bearer ${queryToken}`,
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify(requestBody),
//       })
//         .then((response) => {
//           if (!response.ok) {
//             throw new Error("Unauthorized or invalid response.");
//           }
//           return response.json();
//         })
//         .then((data) => {
//           setUserLocation(data?.data?.user_Location);

//           const rawTime = data?.data?.last_Refresh_Time;
//           const timeWithoutZ = rawTime?.endsWith("Z")
//             ? rawTime.slice(0, -1)
//             : rawTime;

//           let istTime = new Date(timeWithoutZ).toLocaleString("en-IN", {
//             timeZone: "Asia/Kolkata",
//             year: "numeric",
//             month: "numeric",
//             day: "numeric",
//             hour: "numeric",
//             minute: "numeric",
//             second: "numeric",
//             hour12: true,
//           });

//           istTime = istTime.replace("am", "AM").replace("pm", "PM");

//           setRefreshTime(istTime);
//           setHeaderUsername(data?.data?.username);
//         })
//         .catch((error) => {
//           console.error("Error fetching user details:", error);
//           alert("Failed to load user data. Please try logging in again.");
//           setLoading(false);
//         });
//     } catch (err) {
//       console.error("Invalid JWT detected during fetch:", err);
//       alert("Invalid or expired session. Please login again.");
//     }
//   }
// }, [
//   dashboardName, // make sure to include dashboardName in dependencies
//   setLoading,
//   location,
//   setUserLocation,
//   setHeaderUsername,
//   setRefreshTime,
//   apiBaseUrl,
// ]);

// };

export const useFetchUserDetails = (
  setUserLocation,
  setHeaderUsername,
  setRefreshTime,
  apiBaseUrl,
  dashboardName
) => {
  const { setLoading } = useSalesContext();
  const location = useLocation();
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const queryToken = queryParams.get("access_token") || getValidToken();

    if (!queryToken) return;

    try {
      const decoded = jwtDecode(queryToken);
      console.log("Decoded Token:", decoded);

      if (!decoded?.preferred_username) {
        throw new Error("Invalid JWT token structure.");
      }

      const requestBody = { dashboardName };

      setLoading(true);
      fetch(`${apiBaseUrl}User/UserDetails`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${queryToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      })
        .then((response) => {
          if (!response.ok) throw new Error("Unauthorized or invalid response.");
          return response.json();
        })
        .then((data) => {
          const user = data?.data;
          setUserData(user);
          setUserLocation(user?.user_Location || null);
          setHeaderUsername(user?.username || null);

          const rawTime = user?.last_Refresh_Time;
          if (rawTime) {
            const timeWithoutZ = rawTime.endsWith("Z")
              ? rawTime.slice(0, -1)
              : rawTime;

            let istTime = new Date(timeWithoutZ).toLocaleString("en-IN", {
              timeZone: "Asia/Kolkata",
              year: "numeric",
              month: "numeric",
              day: "numeric",
              hour: "numeric",
              minute: "numeric",
              second: "numeric",
              hour12: true,
            });

            istTime = istTime.replace("am", "AM").replace("pm", "PM");
            setRefreshTime(istTime);
          }
        })
        .catch((error) => {
          console.error("Error fetching user details:", error);
          alert("Failed to load user data. Please try logging in again.");
        })
        .finally(() => setLoading(false));
    } catch (err) {
      console.error("Invalid JWT detected during fetch:", err);
      alert("Invalid or expired session. Please login again.");
    }
  }, [
    dashboardName,
    setLoading,
    location,
    setUserLocation,
    setHeaderUsername,
    setRefreshTime,
    apiBaseUrl,
  ]);

  return userData;
};
export const getUserIdFromToken = () => {
  const token = getValidToken();
  let user_id = "";

  if (token) {
    try {
      const decoded = jwtDecode(token);
      user_id = decoded?.employeeID || "";
      console.log("Decoded Token:", decoded);
    } catch (e) {
      console.error("Invalid token", e);
    }
  }

  return user_id;
};

export const useResetRefreshTime = (setRefreshTime) => {
  useEffect(() => {
    const currentDate = new Date();
    currentDate.setHours(2, 0, 0, 0);
    const formattedTime = currentDate.toLocaleString();
    setRefreshTime(formattedTime);
    console.log("Refresh time set to:", formattedTime);
  }, [setRefreshTime]);
};

